<template>
  <div v-loading="loading" style="min-height: 150px">
    <no-data v-if="isNoData" />
    <!-- <div style="margin: 0 0 20px">
      <el-button type="primary" @click="exportData" :loading="exportLoading">导出</el-button><span style="margin-left: 25px;color: red">如果实际结算金额为零时，请代理商先发布完合同信息后，再关注，谢谢！</span>
    </div> -->

    <div>
      <el-table
        :data="orderList.productList"
        border
        style="width: 100%"
        :summary-method="(data) => getSummaries(data, orderList)"
        show-summary
      >
        <el-table-column
          type="index"
          width="50"
          label="序号"
          align="left"
          fixed="left"
        />
        <el-table-column
          prop="productInvoiceName"
          label="商品名称"
          align="left"
          min-width="150"
        />
        <el-table-column
          prop="productName"
          label="规格型号"
          align="left"
          min-width="150"
        />
        <el-table-column prop="count" label="数量" align="left" width="60">
          <template v-slot="{ row }">
            {{ $numToFixed(row.count, 0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="materialUnit"
          label="单位"
          align="left"
          width="60"
        />
        <el-table-column prop="productUnitPrice" label="单价" align="right" header-align="left" width="150">
          <template v-slot="{ row }">
            {{ Number(row.productUnitPrice).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="addTaxesPrice" label="订单金额" align="right" header-align="left" width="150">
          <template v-slot="{ row }">
            {{ Number(row.addTaxesPrice).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="expectedDeliveryDate"
          label="期望发货日期"
          width="150"
          align="left"
        >
          <template v-slot="{ row }">
            {{ row.expectedDeliveryDate.substr(0, 10) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="beforeSplitPrice"
          label="拆分前单价"
          align="right"
          header-align="left"
          width="150"
        />
        <el-table-column prop="amount" label="实际结算金额" align="right" header-align="left" width="150">
          <template v-slot="{ row }">
            {{ Number(row.amount).toFixed(2) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="buyPsc" label="是否购买PSC" align="left" /> -->
        <el-table-column
          prop="shippedCount"
          label="已发货数量"
          align="left"
          width="90"
        >
          <template v-slot="{ row }">
            {{ Number(row.shippedCount).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="unShippedCount"
          label="未发货数量"
          align="left"
          width="90"
        >
          <template v-slot="{ row }">
            {{ Number(row.unShippedCount).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sellingBack"
          label="销退数量"
          align="left"
          width="90"
        >
          <template v-slot="{ row }">
            {{ Number(row.sellingBack).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="taxName"
          label="税收分类名称"
          align="left"
          width="100"
        />
        <el-table-column
          prop="taxRate"
          label="税率"
          align="right"
          header-align="left"
          width="150"
        >
          <template v-slot="{ row }">
            {{ row.taxRate || '0' }}%
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="pname"
            label="序列号"
            align="left"
            width="60"
          >
            <template v-slot="{ row }">
              <lookserial-number
                :str-contract-code="strContractCode"
                :product-name="row.productName"
              />
            </template>
          </el-table-column> -->
        <el-table-column label="是否冲销" align="left" width="80">
          <template v-slot="{ row }">
            {{ row.isBorrow === 'Y' ? "是" : "否" }}
          </template>
        </el-table-column>
      </el-table>
      <address-box
        :prop-open.sync="showAddress"
        @chooseAddress="changeAddress"
      />
    </div>
    <!-- 显示规则：openFlag： Y，不是财务用户 -->
    <!-- <div slot="header" style="font-size: 15px">
        <span>
          <span>配送至：</span>
          <span class="mr-10">{{ address.address }}</span>
          <span class="mr-10">{{ address.consignee }}</span>
          <span class="mr-10">{{ address.tel }}</span>
        </span>
        <el-button
          v-if="address.openFlag ==='Y' && !isFinance"
          type="text"
          style="padding: 0; margin-left: 15px"
          @click.stop="updateAddress(address, index)"
        >
          更改地址
        </el-button>
      </div> -->
  </div>
</template>
<script type="es6">
import noData from '@/components/noData';
import addressBox from '@/views/address/index.vue';
import { getQueryOverseasOrderInfoData } from '@/API/international';
import Big from 'big.js';
import { getNum, numToFixed } from '@/libs/util';

export default {
  data () {
    return {
      tableData: [],
      isNoData: false,
      loading: false,
      addressList: [],
      exportLoading: false,
      nowAddressIndex: null,
      showAddress: false,
      contratType: '',
      orderList: []
    };
  },
  props: {
    // 换货合同编号
    strContractCode: {
      type: String,
      required: true
    },
    // 原单合同号
    oldContractNumCode: {
      type: String,
      required: true
    },
    initInfo: {
      type: Object,
      default: () => { return {}; }
    },
    contractType: {
      type: String,
      default: () => { return ''; }
    }
  },
  watch: {
    initInfo (val) {
      console.log(val, 'val');
    },
    contractType (val) {
      this.contratType = val;
    }
  },

  computed: {
    // 是否财务用户
    isFinance () {
      return this.$store.state.enumeration.telegraphicTransferAuth.includes(this.$store.state.user.userId);
    }
  },

  components: {
    noData,
    // lookserialNumber,
    addressBox
  },

  created () {
    this.initData();
  },

  methods: {
    initData () {
      this.loading = true;
      // 换货合同 contractNum
      // 原合同号 oldContractNum
      let params = {
        contractNum: this.strContractCode,
        oldContractNum: this.oldContractNumCode
      };
      getQueryOverseasOrderInfoData(params).then(res => {
        let { status, data } = res.data;
        this.loading = false;
        if (status === '200') {
          this.addressList = data;
          this.orderList = data[0];
          this.isNoData = !data.length;
        }
      })
        .catch(() => {
          this.loading = false;
        });
    },

    updateAddress (val, index) {
      this.nowAddressIndex = index;
      this.showAddress = true;
    },
    changeAddress (value) {
      console.log(value);
    },
    // 合计
    getSummaries ({ columns, data }, row) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = row.totalCount;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(numToFixed(cur.addTaxesPrice, 2)).plus(pre).toString()), 0);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = numToFixed(row.totalAmount);
          return;
        }
        if (column.label === '已发货数量') {
          sums[index] = row.totalShippedCount;
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(numToFixed(cur.unShippedCount, 0)).plus(pre).toString()), 0);
          return;
        }
        if (column.label === '销退数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(numToFixed(cur.sellingBack, 0)).plus(pre).toString()), 0);
        }
      });
      return sums;
    }
  }
};
</script>

<style scoped>
.mr-10{
  margin-right: 10px;
}
</style>
